<template>
  <div class="home">
    <header class="home-header admin-header">
      <router-link to="/" class="">
        <img
          class="logo"
          src="./../assets/header/logo.png"
          alt="沐桦科技"
        />
       </router-link>
    </header>
    <section class="content user-content login-content">
      <!-- 登陆框 -->
      <div class="content-wrap">
        <div class="account-dialog sign-up-dialog">
          <div class="title">注册</div>
          <!-- 邮箱 -->
          <BasicInput
            type="text"
            icon-type="email"
            class="account-input account-email"
            placeValue=""
            v-model="inputEmail"
            text="邮箱"
          ></BasicInput>
          <div
            v-if="EmailErrMsg"
            class="account-error"
          >
            <i class="el-alert__icon el-icon-error"></i>
            <span class="EmailErrorMsg">{{ EmailErrMsg }}</span>
          </div>
          <div
            v-if="EmailCodeErrMsg"
            class="account-error"
          >
            <i class="el-alert__icon el-icon-error"></i>
            <span class="EmailCodeErrMsg">{{ EmailCodeErrMsg }}</span>
          </div>
          <!-- 密码 -->
          <BasicInput
            type="password"
            icon-type="password"
            class="account-input password-email"
            v-model="inputPw"
            text="密码"
          ></BasicInput>
          <div
            v-if="PwErrMsg"
            class="account-error"
          >
            <i class="el-alert__icon el-icon-error"></i>
            <span class="PwErrMsg">{{ PwErrMsg }}</span>
          </div>
          <!-- 第二密码 -->
          <BasicInput
            type="password"
            icon-type="password"
            class="account-input password-email"
            v-model="inputSePw"
            text="重复密码"
          ></BasicInput>
          <div
            v-if="secPsErrMsg"
            class="account-error"
          >
            <i class="el-alert__icon el-icon-error"></i>
            <span class="secPsErrMsg">{{ secPsErrMsg }}</span>
          </div>
          <div
            class="sign-up-button bonus-cursor"
            v-on:click="signUp"
          >注册</div>
          <div
            class="login-sign-wrap bonus-cursor"
            v-on:click="login"
          >登陆</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import BasicInput from "@/components/BasicInput.vue";
import { mapMutations, mapActions, mapState } from "vuex";
import { Message } from "element-ui";

export default {
  name: "SignUp",
  data() {
    return {
      //输入错误信息时提示
      EmailErrMsg: "",
      ImageCodeErrMsg: "",
      EmailCodeErrMsg: "",
      PwErrMsg: "",
      secPsErrMsg: "",
      // 输入的注册字段
      inputEmail: "",
      inputPw: "",
      inputSePw: "",
      //注册可点击状态
      isSignUpDisable: false,
      agreeProtocol: false
    };
  },
  components: {
    BasicInput
  },
  computed: mapState({
    // 验证码地址
    imageCodeSrc: state => state.signUp.imageCodeSrc,
    siteKey() {
      return SITEKEY.LOW;
    }
  }),
  methods: {
    ...mapActions(["ajaxSignUp"]),
    // 登录
    login() {
      this.$router.push({ name: "Login" });
    },
    // 注册
    signUp() {
      const { inputEmail, inputPw, inputSePw, isSignUpDisable } = this;

      // 避免多次点击
      if (isSignUpDisable) {
        return true;
      }

      // 邮箱验证-----后续建议提出来统一维护
      const emailRule = /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,6}){1,2})$/;
      if (emailRule.test(inputEmail)) {
        this.EmailErrMsg = "";
      } else {
        this.isSignUpDisable = false;
        this.EmailErrMsg = "邮箱错误";
        return true;
      }

      if (inputPw && inputPw.length >= 6) {
        this.PwErrMsg = "";
      } else {
        this.isSignUpDisable = false;
        this.PwErrMsg = "密码错误";
        inputPw.length < 6 && (this.PwErrMsg = "密码需要超过6位数");
        return true;
      }

      if (inputSePw && inputSePw === inputPw) {
        this.secPsErrMsg = "";
      } else {
        this.isSignUpDisable = false;
        this.secPsErrMsg =
          inputSePw === inputPw ? "第二次密码输入错误" : "第二次密码输入错误";
        return true;
      }

      this.ajaxSignUp({
        email: inputEmail,
        password: inputPw,
        rePassword: inputSePw
      }).then(res => {

        this.isSignUpDisable = false;
        if (res && res.code && res.code === 201) {
          Message({
            message: "注册成功，将在3s后跳转",
            type: "success"
          });
          setTimeout(() => {
            this.$router.push({ name: "Admin" });
          }, 3000);
        } else {
          Message(res.message || "网络不好，请重试");
        }
      });
    },
    // 发送邮件码错误提示
    emailCodeTip(error) {
      if (error.type === "captcha") {
        this.EmailCodeErrMsg = error.message;
      } else if (error.type === "email") {
        this.EmailErrMsg = error.message;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.register-content.account-layout {
  height: 60vw;
}

.input-wrap {
  margin: 10px 40px 20px 40px;
}

.sign-up-button {
  box-sizing: border-box;
  margin: 35px 80px 5px;
  background-image: linear-gradient(-180deg, #15BCAD 2%, #10B2CB 100%);
  line-height: 30px;
  height: 30px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  line-height: 30px;
}

.account-input {
  margin: 0 40px;
}

.password-email, .forget-code {
  margin-top: 15px;
}

.login-sign-wrap {
  font-size: 12px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: #00AEEF;
  text-align: right;
  line-height: 36px;
  margin: 0 30px 35px;
}

.account-error {
  box-sizing: border-box;
  padding: 5px 30px 0;
  color: #EE4035;
  font-size: 10px;
}

.el-alert__icon {
  font-size: 10px;
}

.protocol-wrap {
  margin: 15px 30px;
  text-align: left;
  line-height: 14 px;
  font-size: 12px !important;
}

.protocol-wrap .el-radio__label {
  font-size: 12px !important;
}

.sign-up-dialog {
  .sign-up-button {
    background: rgba(0, 174, 239, 1);
    border-radius: 3px;
  }
}

@media screen and (min-width: 1920px) {
  .content-wrap {
    width: 1320px;
    height: 418px;
    background-size: cover;
    margin-top: 250px;
  }

  .sign-up-dialog {
    margin: 0 0 0 60%;
    width: 52%;
    background: #fff;
    border: 1px solid #e3e3e7;
    width: 350px;
    height: 386px
    .title{
      font-size:20px;
      text-align: center;
      padding: 22px 0 32px;
      line-height: 30px;
    }
    .BasicInput.account-input.password-email{
      margin-top: 24px;
    }
    .BasicInput{
      height: 36px;
    }
    .login, .sign-up-button{
      margin: 35px 80px 10px;
      height: 36px;
      line-height: 36px;
    }
    input.basic-input{
      height: 36px;
      line-height: 36px;
      background:rgba(255,255,255,1);
      border-radius:2px;
      border:1px solid rgba(224,224,224,1);
    }
    .icon-wrap{
      line-height: 36px;
    }
  }
}
</style>

